import ButtonFaceMachineServiceRedirect from './ButtonFaceMachineServiceRedirect';
export default ButtonFaceMachineServiceRedirect;
